// Developer note:
// The featured cards, images, videos, and social links shown on /community are managed in Strapi
// via the community-posts, community-videos, and social-links collections. This CTA copy remains a
// frontend config until there is a dedicated CMS model for community page settings.
export const communityContentConfig = Object.freeze({
  inspirationCta: Object.freeze({
    title: 'How to set up your account',
    description:
      'Watch the setup videos below, then review the Buyer Guide, Seller Guide, and FAQ before you start shopping or posting.',
    resources: Object.freeze([
      Object.freeze({
        id: 'buyer-guide',
        label: 'Buyer Guide',
        description: 'Learn how buying, shipping, and order support work on The Mahj Market.',
        linkName: 'BuyerGuidePage',
      }),
      Object.freeze({
        id: 'seller-guide',
        label: 'Seller Guide',
        description: 'Learn how listing, shipping, and payouts work on The Mahj Market.',
        linkName: 'SellerGuidePage',
      }),
      Object.freeze({
        id: 'faq',
        label: 'FAQ',
        description: 'Review the most common buyer and seller questions in one place.',
        linkName: 'FAQPage',
      }),
    ]),
    videos: Object.freeze([
      Object.freeze({
        id: 'account-setup',
        title: 'Account setup walkthrough',
        src: 'https://player.vimeo.com/video/1173778853?h=4b65b967f5',
      }),
    ]),
  }),
});
